export default __webpack_public_path__ + "static/media/popup_real-time_graph.87f90d30.jpg";